import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actionCreators } from "../../store/KPI";
import { bindActionCreators } from "redux";
import loading from "../../assets/loading.gif";
import PieChart2 from "./PieChart2";
import KPILegend from "./KPILegend";
import * as d3 from "d3";

const colorRange = ["#0288D1", "#F5A623", "#E12E2E", "#474747", "#008a93", "#1A3280"];

class DisplayUserKPI extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.kpi.data.length === 0) {
            this.props.getUserKPI();
        }
    }

    render() {
        if (this.props.kpi.data) {
            return (
                <div className="flex-row kpi-container">
                    {this.props.data.map((type) => {
                        return (
                            <div key={type.key} className="flex-column">
                                <div className="kpi-title">
                                    <h2>{type.key}</h2>
                                </div>
                                <div className="kpi-body" style={{ width: '300px' }}>
                                    <div className="flex-row kpi-item">
                                        <div style={{ margin: 'auto' }}>
                                            <PieChart2
                                                data={type.value}
                                                width={175}
                                                height={175}
                                                id={type.key + "Chart"}
                                                colorRange={colorRange} />
                                        </div>
                                    </div>
                                    <KPILegend data={type.value} colorRange={colorRange} history={this.props.history} />
                                </div>
                            </div>
                        )
                    })}
                </div>
            );
        } else {
            return <img src={loading} alt='loading'
                style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
            />
        }
    }
}

export const mapStateToProps = function (state) {
    return {
        user: state.oidc.user,
        kpi: state.kpi,
        //options: state.kpi.options
        data: state.kpi.data
    }
};

export default connect(
    mapStateToProps,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(DisplayUserKPI);